import { installationApi } from "../../api/installationApi"
import { installationListSignal, installationListLoadedSignal, installationListErrorSignal } from "../signals/installationSignals"
import { addNotification, NotificationTypes } from './notificationActions.js'

export async function fetchInstallationList(businessEntityId, config, accessToken, includeChildren = false) {
    installationListLoadedSignal.value = false
    installationListSignal.value = []
    return await installationApi.fetchInstallationList(businessEntityId, config, accessToken, includeChildren).then(
        (result) => {
            installationListSignal.value = result
            installationListLoadedSignal.value = true
            return result
        }
    ).catch(
        (err) => {
            installationListErrorSignal.value = err.message
            throw err
        }
    )
}

export const createInstallation = async (businessEntityId, config, installationManifest, accessToken) => {
    installationListLoadedSignal.value = false
    return await installationApi.createInstallation(businessEntityId, config, installationManifest, accessToken).then(
        async (installation) => {
            return await fetchInstallationList(businessEntityId, config, accessToken).then(
                () => {
                    return installation
                }
            )
        }
    ).catch(
        (error) => {
            installationListErrorSignal.value = error
            throw error
        }
    )
}
export const updateInstallation = async (businessEntityId, installationId, config, installation, accessToken) => {
    installationListLoadedSignal.value = false
    return await installationApi.updateInstallation(businessEntityId, installationId, config, installation, accessToken).then(
        async (updatedInstallation) => {
            return await fetchInstallationList(businessEntityId, config, accessToken).then(
                () => {
                    return updatedInstallation
                }
            )
        }
    ).catch(
        (error) => {
            installationListErrorSignal.value = error
            throw error
        }
    )
}
export const downloadInstallerPackage = async (config, verificationId) => {
    return await installationApi.downloadInstallerPackage(config, verificationId)
}
export const deactivateInstallation = async (config, beId, installationId, accessToken) => {
    return await installationApi.deactivateInstallation(config, beId, installationId, accessToken)
}